import styled from 'styled-components'

export const StyledLink = styled.a`
  text-decoration: none;
  color: ${({ color, theme }) => color || theme.color.font.primary};
  font-size: ${({ size, theme }) => size || theme.color.md};
  margin: ${({ margin }) => margin || 0};
  cursor: pointer;
`
